
























































import { Component, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import {
  GETTER_CLIENT_SETTINGS,
  UPDATE_GX_SETTING_DATA
} from "@/store/constants/setting_types";
import { GETTER_INS_USER_INFO_BY_ID } from "@/store/constants/ins_user_info_types";
import {
  GETTER_CURRENT_EARN_COINS_USER_ID,
  UPDATE_CURRENT_EARN_COINS_USER_ID
} from "@/store/constants/index_types";
import { GETTER_COINS } from "@/store/constants/cg_user_types";
import * as cgConst from "@/api/cg/base/cg_const";
import NavBar from "@/components/NavBarNew/NavBar.vue";
import SelectUser from "@/components/SelectUser/SelectUser.vue";
import Pool from "./Pool/Pool.vue";
import EarnUserGallery from "./AccountAction/EarnUserGallery.vue";
import ButtonGroup from "./ButtonGroup/ButtonGroup.vue";
import { goToCoinStore } from "@/utils/router_helper";
import { feeds_getters } from "@/services/earn_coins/observer/feeds_observer";
import {
  skip_feeds,
  skip_feeds_by_purchased,
  act_feed,
  get_feeds,
  standby_feeds
} from "@/services/earn_coins/controller/feeds_controller";
import {
  act_users_getters,
  act_users_mutation
} from "@/services/earn_coins/observer/act_users_observer";
import { earn_spacing_mutation } from "@/services/earn_coins/observer/spacing_observer";
import { earn_spacing_getters } from "@/services/earn_coins/observer/spacing_observer";
import { skip_delay_getters } from "@/services/earn_coins/observer/skip_delay_observer";
import { goToLogin } from "@/utils/router_helper";
Component.registerHooks(["beforeRouteEnter"]);
@Component({
  components: { NavBar, SelectUser, Pool, ButtonGroup, EarnUserGallery }
})
export default class EarnCoin extends Vue {
  @Getter(GETTER_COINS)
  private userCoins: any;
  @Getter(GETTER_CLIENT_SETTINGS)
  private clientSetting: any;
  @Getter(GETTER_INS_USER_INFO_BY_ID)
  private getterInsUserInfoById: any;
  @Getter(GETTER_CURRENT_EARN_COINS_USER_ID)
  private currentEarnCoinsUserId: any; // 当前earn coins userId
  @Action(UPDATE_GX_SETTING_DATA)
  private updateSettingData: any;
  @Mutation(UPDATE_CURRENT_EARN_COINS_USER_ID)
  private updateCurrentEarnCoinsUserId: any;

  private showInsUserGallery = false; // gallary的开关

  get feeds() {
    return feeds_getters.feeds();
  }

  get pull_status() {
    return feeds_getters.pull_status();
  }

  get feeds_index() {
    return feeds_getters.index();
  }

  get act_user() {
    return act_users_getters.get_act_user(this.currentEarnCoinsUserId);
  }

  get is_skip_delay() {
    return skip_delay_getters.is_skip_delay();
  }

  get skip_delay_end_time_stamp() {
    return skip_delay_getters.end_limit_time_stamp();
  }

  get is_limited_act_user() {
    return act_users_getters.is_limit(this.currentEarnCoinsUserId);
  }

  get end_limit_time_stamp() {
    return this.act_user && this.act_user.end_limit_time_stamp;
  }

  get current_feed() {
    return this.feeds[this.feeds_index] || null;
  }

  get is_abnormal() {
    return act_users_getters.is_login_required(this.currentEarnCoinsUserId);
  }

  get feed_loading_show() {
    return this.pull_status === "running" && this.current_feed === null;
  }

  get is_spacing_limited() {
    return earn_spacing_getters.is_limited();
  }

  get spacing_time_stamp() {
    return earn_spacing_getters.get_limit_time_stamp();
  }

  get current_earn_coins_user_info() {
    return this.currentEarnCoinsUserId
      ? this.getterInsUserInfoById(this.currentEarnCoinsUserId)
      : null;
  }

  get current_user_icon() {
    return this.current_earn_coins_user_info &&
      this.current_earn_coins_user_info.ins_user_info
      ? this.current_earn_coins_user_info.ins_user_info.profile_pic_url
      : null;
  }

  private handle_coin_feed() {
    // 金币feed的点击:
    this.act_feed();
  }

  private close_earn_limited() {
    //
    console.log("close_earn_limited");
    act_users_mutation.update_act_user(this.currentEarnCoinsUserId, {
      is_act_limited: false,
      end_limit_time_stamp: 0
    });
  }

  private close_spacing_limited() {
    earn_spacing_mutation.reset_limited();
  }

  private currentEarnUserChange(userId: string) {
    this.updateCurrentEarnCoinsUserId(userId);
  }

  private show_account_list() {
    // show action list
    this.showInsUserGallery = true;
  }

  private click_select_user() {
    //
    if (this.currentEarnCoinsUserId) {
      this.show_account_list();
    } else {
      goToLogin();
    }
  }

  private click_change_account() {
    // 改变当前账号:
    this.show_account_list();
  }

  private click_add_account() {
    // 添加账号
    goToLogin();
  }

  private click_retry() {
    // 拉取更多:
    standby_feeds();
  }

  private clickCoinsIcon() {
    //
    goToCoinStore();
  }

  private skip_feed() {
    skip_feeds();
  }

  private act_feed() {
    act_feed(this.currentEarnCoinsUserId, this.current_feed);
  }

  private click_ads_feed() {
    // 点击广告
    this.act_feed();
  }

  private click_more() {
    goToCoinStore();
  }

  // ======================== lifecycle =========================

  private beforeRouteEnter(to: any, from: any, next: any) {
    console.log("to", to, from);
    next((vm: any) => {
      console.log("from", from);
      if (from.name === "OrderDetail") {
        // need change current purchase feed
        skip_feeds_by_purchased(this.current_feed);
      }
    });
  }

  private created() {
    this.updateSettingData(cgConst.TAB_EARN_COINS_KEYS).catch(
      (e: any) => void 0
    );
  }

  private mounted() {
    get_feeds();
  }
}
